const initialState = {
    data: [],
  };
  
const przelewyReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PRZELEWY':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default przelewyReducer;